export const cards = {
    cardDisplay: {
        showButtonThemeLesson: false,
        showButtonBookmarks: {
            themes: false,
            lesson: true,
            model: false,
            community: false,
            image: false,
            video: false,
            videoUrl: false,
            audio: false,
            document: false,
            url: false,
        },
        isTextButton: false,
    },
    cardDefaultHeader: '/assets/marqueblanche/images/backgrounds/header.png',
    cardFields: {
        default: {
            lesson: ['title', 'titleIcon', 'menu', 'dynamicLevelTypeImage', 'educationalLevel', 'description', 'skills', 'assignation_type', 'button-assign-as-label-in-action-menu'],
            model: ['title', 'titleIcon', 'menu', 'dynamicLevelTypeImage', 'educationalLevel', 'description', 'skills', 'assignation_type', 'button-assign-as-label-in-action-menu'],
            /* lesson: ['title', 'menu', 'dynamicLevelTypeImage', 'educationalLevel', 'description', 'assignation_type'],
             model: ['title', 'menu', 'dynamicLevelTypeImage', 'educationalLevel', 'description', 'assignation_type'],*/
            community: ['title', 'menu', 'dynamicLevelTypeImage', 'educationalLevel', 'description', 'assignation_type'],
            image: ['title', 'titleIcon', 'menu', 'image', 'skills', 'difficulty'],
            video: ['title', 'titleIcon', 'menu', 'image', 'skills', 'difficulty'],
            videoUrl: ['title', 'titleIcon', 'menu', 'image', 'skills', 'difficulty'],
            audio: ['title', 'titleIcon', 'menu', 'image', 'skills', 'difficulty'],
            document: ['title', 'titleIcon', 'menu', 'image', 'skills', 'difficulty'],
            url: ['title', 'titleIcon', 'menu', 'image', 'skills', 'difficulty'],
        }
    },
    cardPlayOpenMenu: false,
    menuLinks: {
        lesson: {
            manager: [
                'editAndDeleteAssignments',
                'deleteWithAssignments',
                'duplicate'
            ],
            default: [
                'editAndDeleteAssignments',
                'deleteWithAssignments',
                'assign',
                'duplicate'
            ],
            trainer: ['add', 'assignIcon', 'duplicateAndEdit', 'deleteOrDisable']
        },
        model: {
            manager: [
                'editAndDeleteAssignments',
                'deleteWithAssignments',
                'duplicate'
            ],
            trainer: ['assign', 'duplicateAndEdit'],
            default: [
                'assign',
                'duplicate'
            ]
        }
    },
    moveActionsButtonInMenu: { // Display all button in menu button except bookmark and open lesson page
        default: {
            lesson: true,
            default: true,
        }
    },
    isEditOrDisableButtonActive: {
        default: false,
        trainer: true
    },
    buttonAssignIconConditionNotUseShowButtonAssign: false,
    showCardHeaderMenu: false,
};
